import { render, staticRenderFns } from "./DungeonDetailDialog.vue?vue&type=template&id=0fff5d6e&scoped=true"
import script from "./DungeonDetailDialog.vue?vue&type=script&lang=js"
export * from "./DungeonDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./DungeonDetailDialog.vue?vue&type=style&index=0&id=0fff5d6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fff5d6e",
  null
  
)

export default component.exports